export const GET_AUTH_INFO = "GET_AUTH_INFO";
export const LOGOUT = "LOGOUT";
export const LOGGED = "LOGGED";
export const GET_TOKEN = "GET_TOKEN";
export const NOT_EDITED = "NOT_EDITED";
export const EDITED = "EDITED";
